// El plazo del aviso «Instala TEGO en tu teléfono» (R-PWA-7): «Ahora no» lo
// guarda 14 días. Vive aparte del componente para que el refresco en
// caliente de React no se rompa (`react-refresh/only-export-components`).
export const CLAVE_AVISO = 'tego.pwa.aviso_cerrado';
export const DIAS_SIN_AVISAR = 14;
const MS_POR_DIA = 24 * 60 * 60 * 1000;

export function cerradoHacePoco(ahora = Date.now()) {
  try {
    const v = Number(localStorage.getItem(CLAVE_AVISO) || 0);
    return v > 0 && ahora - v < DIAS_SIN_AVISAR * MS_POR_DIA;
  } catch { return false; }
}

export function anotarCierre(ahora = Date.now()) {
  try { localStorage.setItem(CLAVE_AVISO, String(ahora)); } catch { /* sin almacenamiento */ }
}
